import { DesktopFilterSelectOptionHrefParams } from './DesktopFilterSelectOption.types';
import { QUERY } from '@/constants/common';
import { ROUTES } from '@/constants/routes';

export function preserveUserIdInDesktopFilterQuery(pathname: string): boolean {
  return pathname.startsWith(`${ROUTES.shops}/`);
}

export function getDesktopFilterSelectOptionHref({
  clearUrl,
  value,
  baseSearchParams,
  queryString,
  propertyParam,
  queryParam,
  pathname,
}: DesktopFilterSelectOptionHrefParams) {
  const searchParams = new URLSearchParams(baseSearchParams ?? queryString);
  const key =
    baseSearchParams || propertyParam
      ? `p[${propertyParam}]`
      : `${QUERY.q}[${queryParam}]`;

  const resolvedPath =
    pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
  if (!preserveUserIdInDesktopFilterQuery(resolvedPath)) {
    searchParams.delete(QUERY.userId);
  }
  // The current URL may already carry keywordsSource from an earlier
  // search/filter action — drop it here so it doesn't leak into every
  // sibling option's markup, it's re-added only on an actual click.
  searchParams.delete(QUERY.keywordsSource);

  if (value !== undefined) {
    searchParams.set(key, value);
  } else {
    searchParams.delete(key);
  }

  const restQueryString = searchParams.toString();

  return restQueryString ? `${clearUrl}?${restQueryString}` : clearUrl;
}
